/**
 * Query stale time configuration.
 * Aligns with Consumer Duty's per-data-type caching strategy.
 */

/** Real-time data that changes frequently (alerts, notifications, active incidents) */
export const STALE_TIME_REALTIME = 1000 * 60 * 1 // 1 minute

/** Operational data that updates regularly (metrics, performance, KRIs) */
export const STALE_TIME_OPERATIONAL = 1000 * 60 * 5 // 5 minutes

/** Structural/reference data that rarely changes (IBS registry, systems, infrastructure, teams, suppliers, locations) */
export const STALE_TIME_STRUCTURAL = 1000 * 60 * 30 // 30 minutes

/** Configuration data that almost never changes (roles, permissions, categories, settings) */
export const STALE_TIME_CONFIG = 1000 * 60 * 60 // 1 hour

/**
 * Get the appropriate stale time for a query key.
 * Pass the first element of your queryKey array.
 */
export function getStaleTime(queryKeyPrefix: string): number {
  const realtimeKeys = ['alerts', 'notifications', 'incidents', 'active-incidents']
  const operationalKeys = ['metrics', 'performance', 'kris', 'dashboards', 'monitoring']
  const configKeys = ['roles', 'permissions', 'categories', 'settings', 'system-categories', 'infrastructure-categories']

  if (realtimeKeys.includes(queryKeyPrefix)) return STALE_TIME_REALTIME
  if (operationalKeys.includes(queryKeyPrefix)) return STALE_TIME_OPERATIONAL
  if (configKeys.includes(queryKeyPrefix)) return STALE_TIME_CONFIG
  return STALE_TIME_STRUCTURAL // default for most entity data
}
